import { TransactionNotifyService } from "./transaction.notify.service";
import { Injectable } from "@angular/core";
import { IndexTransaction } from "@models/transaction";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";
import { Router } from "@angular/router";

@Injectable({
	providedIn: "root"
})
export class IndexTransactionNotifyService extends TransactionNotifyService<IndexTransaction> {
	protected LABEL: string = "index";

	public constructor(
		public router: Router,
		protected translationService: TranslationService,
		protected infoService: InfoService
	) {
		super(router);
	}

	protected caseNew(transaction: IndexTransaction): string {
		if (transaction.getType() === "transfer" || transaction.getType() === "withdrawal") {
			return "send-successfull";
		}
		if (transaction.isSwap()) {
			return "swap_successful";
		}
		return transaction.getType() + "_successful";
	}
}
